import React from 'react';

class Layout extends React.Component {
    render() {
        return (
            <div className={ 'col-xs-12 text-left' } style={{marginTop: '-5%'}} >
                <div className={ 'page-header' } >Maintain Lab</div>
                <div className={ 'user-form img-rounded' } >
                    {this.props.children}
                </div>
            </div>
        )
    }

}

export default Layout;